// Color constants matching mobile app exactly
export const COLORS = {
  primary: '#8B5CF6',
  primaryDark: '#7C3AED',
  primaryLight: '#A78BFA',
  accent: '#EC4899',
  accentBlue: '#3B82F6',
  accentCyan: '#06B6D4',
  accentGreen: '#10B981',
  accentOrange: '#F59E0B',
  accentRed: '#EF4444',
  accentIndigo: '#6366F1',
  accentTeal: '#14B8A6',
  background: '#1A1A24',
  surface: '#2A2A38',
  surfaceLight: '#2A2A38',
  textPrimary: '#FAFAFA',
  textSecondary: '#B8B8C7',
  textTertiary: '#6B6B7B',
  success: '#10B981',
  error: '#EF4444',
  warning: '#F59E0B',
} as const;

// Aspect ratio options
export const ASPECT_RATIOS = ['auto', '16:9', '9:16', '1:1'] as const;

// Duration options (fal.ai)
export const DURATIONS = ['4s', '6s', '8s', '12s'] as const;

// HeyGen duration range: 5s to 300s in 5s increments
export const HEYGEN_MIN_DURATION = 5;
export const HEYGEN_MAX_DURATION = 300;
export const HEYGEN_DURATION_STEP = 5;

// HeyGen pricing: 6 credits per 5 seconds, rounded UP. e.g. 23/24/25s = 30
// credits; 26s = 36. Must match the backend formula in
// lambdas/heygen-chat-message (Python: math.ceil(duration/5) * 6).
export const HEYGEN_CREDITS_PER_5SEC = 6;

export function calculateHeygenCredits(durationSec: number): number {
  if (!Number.isFinite(durationSec) || durationSec <= 0) return 0;
  return Math.ceil(durationSec / 5) * HEYGEN_CREDITS_PER_5SEC;
}

// Resolution options
export const RESOLUTIONS = ['720p', '1080p'] as const;

// File type helpers
export function getFileTypeFromOperation(operationType: string): 'video' | 'audio' | 'image' {
  if (operationType === 'image_generation') return 'image';
  return 'video';
}

export function getOperationDisplayName(operationType: string): string {
  const names: Record<string, string> = {
    text_to_video: 'Text to Video',
    image_to_video: 'Image to Video',
    first_frame_last_frame: 'Frame Animation',
    video_to_video: 'Video to Video',
    remove_video_background: 'Remove Background',
    upscale_video: 'Upscale Video',
    lipsync: 'Lipsync',
    auto_caption: 'Auto Caption',
    dubbing: 'Dubbing',
    ai_avatar: 'AI Avatar',
    effects: 'Effects',
    reframe_aspect_ratio: 'Reframe',
    multiple_images: 'Multiple Images',
  };
  return names[operationType] || operationType.replace(/_/g, ' ');
}
